import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CoreEvents<T> {
  private channels: {
    [key: string]: BehaviorSubject<T | undefined>;
  } = {};

  /**
   * Gets the channel.
   */
  public get(channel: string): BehaviorSubject<T | undefined> {
    if (!this.channels[channel]) {
      this.register(channel);
    }

    return this.channels[channel];
  }

  /**
   * Gets the channel value.
   */
  public getValue(channel: string): T | undefined {
    if (!this.channels[channel]) {
      this.register(channel);
    }

    return this.channels[channel].value;
  }

  /**
   * Register a channel.
   */
  public register(channel: string): void {
    if (this.channels[channel]) {
      return;
    }

    console.info('[CoreEvents] register', channel);
    this.channels[channel] = new BehaviorSubject<T | undefined>(undefined);
  }

  /**
   * Subscribe to a channel.
   */
  public subscribe(channel: string, observer: (_?: T) => void): Subscription {
    if (!this.channels[channel]) {
      this.register(channel);
    }

    console.info('[CoreEvents] subscribe', channel);

    return this.channels[channel].subscribe(observer);
  }

  /**
   * Publish data for a channel.
   */
  public publish(channel: string, data?: T): void {
    if (!this.channels[channel]) {
      this.register(channel);
    }

    console.info('[CoreEvents] publish', channel, data);
    this.channels[channel].next(data);
  }

  /**
   * Destroy a channel.
   */
  public destroy(channel: string): void {
    if (!this.channels[channel]) {
      return;
    }

    console.info('[CoreEvents] destroy', channel);
    this.channels[channel].complete();
    delete this.channels[channel];
  }
}
